import { render, staticRenderFns } from "./EditOrganisation.vue?vue&type=template&id=3453c72a&scoped=true"
import script from "./EditOrganisation.vue?vue&type=script&lang=js"
export * from "./EditOrganisation.vue?vue&type=script&lang=js"
import style0 from "./EditOrganisation.vue?vue&type=style&index=0&id=3453c72a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453c72a",
  null
  
)

export default component.exports